import React from 'react';
import loadable from 'react-loadable';

const Loading = () => <div>Loading...</div>;

export const Home = loadable({
  loader: () => import('./Home'),
  loading: Loading,
  delay: 100,
});


export const Demo1 = loadable({
  loader: () => import('./Demo2'),
  loading: Loading,
  delay: 100,
});

export const Demo2 = loadable({
  loader: () => import('./Demo1'),
  loading: Loading,
  delay: 100,
});

export const Demo3 = loadable({
  loader: () => import('./Demo3'),
  loading: Loading,
  delay: 100,
});

export const Demo4 = loadable({
  loader: () => import('./Demo4'),
  loading: Loading,
  delay: 100,
});

